import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CheckCircle2, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../mock';
import { ChristmasPreviewGrid } from './ChristmasPreviewGrid';

export const ChristmasLights = () => (
      <section
        id="christmas-lights"
        className="relative py-24 bg-[#0b1220] text-white overflow-hidden"
        data-testid="christmas-lights-section"
      >
        {/* Subtle grid + warm vignette — professional electrical palette, no AI glow */}
        <div
          className="absolute inset-0 opacity-30 pointer-events-none"
          aria-hidden="true"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        ></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-yellow-400/5 blur-3xl pointer-events-none" aria-hidden="true"></div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <div className="inline-flex items-center space-x-2 bg-yellow-400/10 border border-yellow-400/40 rounded-full px-4 py-1.5 mb-5">
              <Sparkles className="w-4 h-4 text-yellow-400" />
              <span className="text-sm font-semibold text-yellow-400 tracking-wide uppercase">
                Now Booking Holiday Season 2025
              </span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold text-white mb-4"
              data-testid="christmas-lights-heading"
            >
              Christmas Light Installation <span className="text-yellow-400">in Brooklyn</span> & Surrounding Areas
            </h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto mb-5"></div>
            <p className="text-lg text-gray-300">
              Custom-designed, professionally installed holiday lighting for brownstones, townhomes, and storefronts.
              Commercial-grade warm-white LEDs, zero roof damage, in-season maintenance, and January takedown — all included.
            </p>
          </div>

          <ChristmasPreviewGrid />

          {/* Feature chips */}
          <div className="flex flex-wrap items-center justify-center gap-3 max-w-4xl mx-auto mb-10">
            {[
              'Custom Roofline Design',
              'Commercial-Grade Warm-White LEDs',
              'Zero Roof Damage',
              'In-Season Maintenance',
              'January Takedown Included',
              'Fully Insured',
            ].map((feat) => (
              <span
                key={feat}
                className="inline-flex items-center space-x-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-gray-200"
              >
                <CheckCircle2 className="w-4 h-4 text-yellow-400" />
                <span>{feat}</span>
              </span>
            ))}
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/christmas-light-installation-brooklyn" data-testid="christmas-lights-service-cta">
              <Button
                size="lg"
                className="bg-yellow-400 hover:bg-yellow-300 text-black font-bold px-8 py-6 text-base shadow-lg shadow-yellow-500/20"
              >
                <Sparkles className="w-5 h-5 mr-2" />
                See Full Service &amp; Pricing
              </Button>
            </Link>
            <a href={`tel:${companyInfo.phone}`} data-testid="christmas-lights-phone-cta">
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black bg-transparent px-8 py-6 text-base"
              >
                <Phone className="w-5 h-5 mr-2" />
                Book Install — {companyInfo.phone}
              </Button>
            </a>
          </div>
        </div>
      </section>
);
